import React from 'react';
import { Box } from '@mui/material';

import { ProductGroupSelectEnhancedContainer as ProductGroupSelect } from './ProductGroupSelectEnhanced/ProductGroupSelectEnhancedContainer';

import { ButtonGroup } from '../../ButtonGroup';
import { State } from '../redux';

type ComponentState = State['emConfiguration']['totalEligiblePurchase'];
type Fields = keyof ComponentState;
export type Props = ComponentState & {
  editMode: boolean;
  fieldDisabled: (field: Fields) => boolean;
};

const TotalEligiblePurchaseConfiguration: React.FC<Props> = (props) => {
  const { countProductsBy, editMode, eligibleProductGroups, fieldDisabled, roundCountedProducts } =
    props;

  return (
    <Box>
      <Box mb={4}>
        <ButtonGroup
          label='Count Product By'
          name='countProductsBy'
          readonly={fieldDisabled('countProductsBy')}
          selectedValue={countProductsBy}
        >
          <ButtonGroup.Option value='quantity'>Quantity</ButtonGroup.Option>
          <ButtonGroup.Option value='money_amount'>Money Amount</ButtonGroup.Option>
        </ButtonGroup>
      </Box>

      <Box mb={4}>
        <ButtonGroup
          label='Round Counted Products'
          name='roundCountedProducts'
          readonly={fieldDisabled('roundCountedProducts')}
          selectedValue={roundCountedProducts}
        >
          <ButtonGroup.Option value='half_up'>Half Up</ButtonGroup.Option>
          <ButtonGroup.Option value='down'>Down</ButtonGroup.Option>
          <ButtonGroup.Option value='raw'>Raw</ButtonGroup.Option>
        </ButtonGroup>
      </Box>

      <Box mb={4}>
        <ProductGroupSelect
          editMode={editMode}
          label='Included Product Groups'
          onChange={() => {}}
          readonly={fieldDisabled('eligibleProductGroups')}
          selectedProductGroups={eligibleProductGroups}
        />
      </Box>
    </Box>
  );
};

export { TotalEligiblePurchaseConfiguration };
